var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.186,
    height: 16,
    viewBox: "0 0 15.186 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9735",
    "data-name": "Grupo 9735",
    transform: "translate(-1192.48 -126.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11802",
    "data-name": "Caminho 11802",
    d: "M1207.666,126.75h-3.451V130.2h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11803",
    "data-name": "Caminho 11803",
    d: "M1201.8,126.75h-3.451V130.2h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11804",
    "data-name": "Caminho 11804",
    d: "M1207.666,133.025h-3.451v3.45h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11805",
    "data-name": "Caminho 11805",
    d: "M1201.8,133.025h-3.451v3.45h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11806",
    "data-name": "Caminho 11806",
    d: "M1207.666,139.3h-3.451v3.451h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11807",
    "data-name": "Caminho 11807",
    d: "M1201.8,139.3h-3.451v3.451h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11808",
    "data-name": "Caminho 11808",
    d: "M1195.931,126.75h-3.451V130.2h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11809",
    "data-name": "Caminho 11809",
    d: "M1195.931,133.025h-3.451v3.45h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11810",
    "data-name": "Caminho 11810",
    d: "M1195.931,139.3h-3.451v3.451h3.451Z",
    fill: "#415364"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCards);
export default __webpack_public_path__ + "static/media/icon-cards.85ff46c516177d722123213331672fdf.svg";
export { ForwardRef as ReactComponent };